module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header page"
  }, [_c('div', {
    staticClass: "contaner"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('router-link', {
    attrs: {
      "to": "/pc",
      "tag": "li"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Speech'
      },
      "tag": "li"
    }
  }, [_vm._v("跨年演讲")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'University'
      },
      "tag": "li"
    }
  }, [_vm._v("得到大学")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'News'
      },
      "tag": "li"
    }
  }, [_vm._v("新闻报道")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Download'
      },
      "tag": "li"
    }
  }, [_vm._v("App 下载")]), _vm._v(" "), _vm._m(2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/pc"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/join"
    }
  }, [_vm._v("校园招聘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://qiye.igetget.com/",
      "target": "_blank"
    }
  }, [_vm._v("企业服务")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45902743"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/www/Components/Header.vue
// module id = 45
// module chunks = 8